import header from "./grundriss-tablet.webp";
import section1 from "./mann-laser-messung-raum.webp";
import section2 from "./frau-computer-grundriss-erstellung.webp";
import section3 from "./grundriss-beispiel.png";

export { header, section1, section2, section3 };
